<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>Mail Escalate</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content class="p-15">
  <div class="row forwardMdl">
    <div class="col-12 mb-10">
      <span class="heading">TO : </span>
      <span class="description">
        <!-- <fn-tag
          [showLabel]="false"
          [placeholder]="'Select TO Mail Id(s)'"
          (addCallback)="selectMail($event)"
          [itemTags]="mailTeamArray"
          (inputChange)="onMailInputChange($event)"
          >
        </fn-tag> -->
        <div class="chip-container">
          <div class="chip_wrap">
            <div class="chip" *ngFor="let item of selectedMail; let i = index">
              {{ item }}
              <span class="remove" (click)="removeEmail(i)">&times;</span>
            </div>
          </div>
          <input
            class="chipData"
            type="text"
            [(ngModel)]="emailInput"
            (input)="filterEmails()"
            (keydown.enter)="addEmailFromInput()"
            placeholder="Type email and press Enter"
            autocomplete="off"
          />
        </div>

        <ul *ngIf="filteredEmailSuggestions.length > 0" class="suggestion-box">
          <li
            *ngFor="let item of filteredEmailSuggestions"
            (click)="addEmail(item)"
          >
            {{ item }}
          </li>
        </ul>
      </span>
    </div>
    <div class="col-12 mb-10">
      <span class="heading">CC : </span>
      <span class="description">
        <fn-multi-select
          [labelKey]="'defaultEscEmailID'"
          [inputKey]="'defaultEscEmailID'"
          disabled="true"
          [placeholder]="'Select CC Mail Id(s)'"
          [(ngModel)]="ccMailTeamArray"
        ></fn-multi-select>
      </span>
    </div>
    <div class="col-12 mb-10 form-control addAttachment">
      <input
        #fileUploadInput
        type="file"
        id="fileupload_id"
        class="d-none"
        multiple
        (change)="handleSelectedFile($event)"
      />
      <div class="attach-file text-center" (click)="triggerFileUpload()">
        <span>
          <i class="fn-global-attachment font-15 mr-5"></i>{{ fileName }}
        </span>
      </div>
    </div>

    <div class="col-2">
      <div class="">
        <label>Telegram</label>
        <fn-checkbox
          [(ngModel)]="isSendTelegram"
          (change)="selectionCheck($event)"
          [value]=""
        ></fn-checkbox>
      </div>
    </div>

    <div class="col-10">
      <textarea
        class="form-control commentArea"
        placeholder="Add your comment here..."
        [(ngModel)]="commentObject.textComment"
      ></textarea>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-6 text-left">
      <button class="btn btn-danger float-left btn-round" (click)="close()">
        Cancel
      </button>
    </div>
    <div class="col-6 text-right">
      <button
        class="btn btn-primary float-right btn-round"
        (click)="escalate()"
      >
        Esclate
      </button>
    </div>
  </div>
</mat-dialog-actions>
